import React, {
  useRef,
  useEffect,
} from 'react';
import * as Sentry from '@sentry/react';
import MainInput from './MainInput';
import {
  MOBILE_BG_VIDEO_TS,
  PC_BG_VIDEO_MP4,
  PC_BG_VIDEO_WEBM,
} from './media';
import style from './index.module.scss';

/** 上报首屏 JSMpeg 生命周期异常，监控失败时不再向页面抛出新错误。 */
function reportJSMpegError(error: unknown, operation: 'create' | 'destroy') {
  try {
    Sentry.captureException(error, {
      tags: {
        app: 'oversea',
        stage: 'jsmpeg/mainScreen',
      },
      extra: { operation },
    });
  } catch (reportError) {
    console.error('[Oversea] MainScreen JSMpeg report failed:', reportError);
  }
}

/** 渲染海外首页首屏，并在移动端安全初始化背景 JSMpeg 播放器。 */
export default function MainScreen({ isJSMpegLoaded, isPhone }: { isJSMpegLoaded: boolean; isPhone: boolean; }) {
  const videoRef = useRef<HTMLVideoElement>(null);
  const canvasVideoRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    if (!isJSMpegLoaded || !canvasVideoRef.current || !isPhone) return;
    const { JSMpeg } = window as any;
    if (!JSMpeg) return;
    let player: any;
    try {
      player = new JSMpeg.Player(MOBILE_BG_VIDEO_TS, {
        canvas: canvasVideoRef.current,
        autoplay: true,
        loop: true,
        audio: false,
      });
    } catch (error) {
      reportJSMpegError(error, 'create');
      return;
    }
    // eslint-disable-next-line consistent-return
    return () => {
      try {
        player?.destroy?.();
      } catch (error) {
        reportJSMpegError(error, 'destroy');
      }
    };
  }, [isJSMpegLoaded, isPhone]);

  // useEffect(() => {
  //   // iOS Safari fallback: 手动触发播放
  //   const video = videoRef.current;
  //   if (video) {
  //     video.load();
  //     video.play().catch(() => {
  //       // 忽略自动播放被阻止的错误
  //     });
  //   }
  // }, [isMobile]);

  return (
    <div className={style.main_screen}>
      {isPhone && (
        <canvas ref={canvasVideoRef} className={style.background_video} aria-label="Main screen illustration" />
      )}
      {!isPhone && (
      <video
        ref={videoRef}
        muted
        autoPlay
        playsInline
        loop
        crossOrigin="anonymous"
        className={style.background_video}
      >
        <source type="video/webm" src={PC_BG_VIDEO_WEBM} />
        <source type="video/mp4" src={PC_BG_VIDEO_MP4} />
      </video>
      )}
      <div className={style.center_box}>
        <h1>
          <span>Stunning visuals, effortless effects, flawless execution.</span>
          Create the next big hit.
        </h1>
        <p className={style.creation_tips}>Explore Short Drama Creation Now</p>

        <MainInput />
      </div>

      <div className={style.scene_box}>
        This video was generated by RoboNeo.
      </div>

      <div className={style.linear_gradient_box} />
    </div>
  );
}
